<div class="item user-block" *ngIf="userBlockIsVisible()">
    <!-- User picture-->
    <div class="icon fas fa-user"></div>
    <!-- Name and Job-->
    <div class="user-block-info">
        <span class="user-block-name text-dark">{{ 'sidebar.WELCOME' | translate }}  {{ userName }}</span>
    </div>
</div>
